import { SatelliteViewType, StructureImageMetadataType } from 'data/types';
import { normalizeHeading } from 'utils/satellite-heading';

export function satelliteViewFromMetadata(
  metadata: StructureImageMetadataType[]
): SatelliteViewType | null {
  const withView = metadata.filter(
    (item) =>
      item.lat != null &&
      item.lng != null &&
      item.zoom != null &&
      item.heading != null
  );
  if (withView.length === 0) {
    return null;
  }

  const item = withView.reduce((latest, current) =>
    current.attachmentId > latest.attachmentId ? current : latest
  );

  return {
    lat: Number(item.lat),
    lng: Number(item.lng),
    zoom: Number(item.zoom),
    heading: normalizeHeading(Number(item.heading))
  };
}

export function appendSatelliteViewToFormData(
  formData: FormData,
  view: SatelliteViewType
): void {
  formData.append('lat', String(view.lat));
  formData.append('lng', String(view.lng));
  formData.append('zoom', String(view.zoom));
  formData.append('heading', String(view.heading));
}
